import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { FicheIntervention } from 'app/models/ficheIntervention.model';
import { FicheInterventionService } from 'app/services/fiche-intervention.service';
import { startOfDay, addHours, isSameDay, isSameMonth } from 'date-fns';

@Component({
  selector: 'app-calendrier',
  templateUrl: './calendrier.component.html',
  styleUrls: ['./calendrier.component.scss']
})
export class CalendrierComponent implements OnInit {

  isLoaded: boolean = false;
  activeDayIsOpen: boolean = true;

  view: CalendarView = CalendarView.Month;
  fichesInterventions: FicheIntervention[] = [];
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];

  constructor(private ficheInterventionService: FicheInterventionService, private router: Router) {}

  ngOnInit(): void {
    this.getFichesInterventions();
  }

  getFichesInterventions(): void {
    this.ficheInterventionService.getAllFichesInterventions(['dossierIntervention']).subscribe((fichesInterventions) => {
        this.fichesInterventions = fichesInterventions;
        this.isLoaded = true;

        const startDate = startOfDay(new Date());
        this.fichesInterventions.forEach((ficheIntervention) => {
          const date = new Date(ficheIntervention.date_intervention);
          if(ficheIntervention.dossier_intervention) {
              this.events.push({
                  start: addHours(date, 9),
                  end: addHours(date, 12),
                  title: 'Dossier: ' + ficheIntervention.dossier_intervention.no_dossier,
                  color: {
                      primary: '#e3bc08',
                      secondary: '#FDF1BA'
                  },
                  meta: {
                      location: 'New York',
                      dossier_id: ficheIntervention.dossier_intervention_id,
                      ficher_id: ficheIntervention.id
                  }
              });
          }
        });

        console.log(this.events);

        this.viewDate = new Date(); // La date d'aujourd'hui pour que le calendrier refresh.
    });
  }

  eventClicked({ event }: { event: CalendarEvent }): void {
    this.router.navigate(['/dossiers-interventions', event.meta.dossier_id]);
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }
}
